<!--
* @Name：议价审批
* @Author: 刘玉
* @Date: 2021-12-02 10:47:19
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 10:47:19
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="议价审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">价格申请基本信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="materialDetails">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">物料信息明细</span>
        </template>
        <material-details :details-list="detailsList" :history-price-list="historyPriceList" />
      </van-collapse-item>
      <van-collapse-item name="moldAllocation">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">模具分摊</span>
        </template>
        <mold-allocated :details-list="detailsList" />
      </van-collapse-item>
      <van-collapse-item name="tieredPricing">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">阶梯价格</span>
        </template>
        <tiered-pricing :details-list="detailsList" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { selectPmPriceBargainInfoById, selectHistoryPice } from '@/api/bargain.js'
import Bridge from '@/components/dsbridge'
export default {
  name: 'BargainApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'material-details': () => import('./components/MaterialDetails.vue'),
    'mold-allocated': () => import('./components/MoldAllocated.vue'),
    'tiered-pricing': () => import('./components/TieredPricing.vue')
  },
  data() {
    return {
      // bargainId: this.$store.getters.businessKey,
      bargainId: this.$route.query.businessKey,
      activeNames: ['baseInfo', 'approvalOpinions'],
      headInfo: {},
      detailsList: [],
      historyPriceList: [],
      attachList: []
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      const response = await selectPmPriceBargainInfoById({ bargainId: this.bargainId })
      this.headInfo = response.data
      this.attachList = response.data.files
      this.detailsList = response.data.pmPriceBargainItemDTOList
      const matnrList = this.detailsList.map(item => item.matnr)
      const historyPriceResp = await selectHistoryPice(matnrList, '40')
      this.historyPriceList = historyPriceResp.data
    },
    onClickLeft() {
      // this.$router.push('/todo')
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
